import { useMemo } from 'react';
import { ColumnDef, Row } from '@tanstack/react-table';
import { createSelectionColumn } from '../SelectionColumn';
import { createExpanderColumn } from '../cells/ExpanderCell/ExpanderColumn';

interface UseColumnsProps<T> {
  columns: ColumnDef<T>[];
  enableRowSelection: boolean | ((row: Row<T>) => boolean);
  /** Если true — автоматически добавляется колонка-expander (плюсик) */
  hasExpandableRows?: boolean;
}

interface ColumnsState<T> {
  updatedColumns: ColumnDef<T>[];
}

/**
 * Custom hook that handles column management including selection and expander columns
 */
export function useColumns<T>({
  columns,
  enableRowSelection,
  hasExpandableRows,
}: UseColumnsProps<T>): ColumnsState<T> {
  const updatedColumns = useMemo<ColumnDef<T>[]>(() => {
    let result = columns;
    if (hasExpandableRows) {
      result = [createExpanderColumn<T>(), ...result];
    }
    if (enableRowSelection) {
      result = [createSelectionColumn<T>(), ...result];
    }
    return result;
  }, [columns, enableRowSelection, hasExpandableRows]);

  return {
    updatedColumns,
  };
}
